export const BILLS_TAB = 'BILLS';
